import React from "react";
import "./Harsafe_Meet_ServiceSection.css";
import { FaComments, FaPhoneAlt, FaLock, FaUsers, FaPaperclip, FaBell, FaCamera, FaDesktop, FaCloudUploadAlt } from 'react-icons/fa';

// import Lock_Unlock from "./src/img/dshield";


const services = [
  {
    icon: FaComments,
    imgAlt: "Real-Time Messaging",
    title: "Real-Time Messaging",
    description: "Stay connected with instant messaging, enabling smooth and fast communication anytime, anywhere."
  },
  {
    icon: FaPhoneAlt,
    imgAlt: "Voice and Video Calls",
    title: "Voice and Video Calls",
    description: "Crystal-clear voice and video calls to stay in touch with your loved ones effortlessly."
  },
  {
    icon: FaLock,
    imgAlt: "End-to-End Encryption",
    title: "End-to-End Encryption",
    description: "Your conversations are fully secured with top-notch end-to-end encryption for complete privacy."
  },
  {
    icon: FaUsers,
    imgAlt: "Group Chats and Calls",
    title: "Group Chats and Calls",
    description: "Collaborate or connect with friends and colleagues using easy group chat and call options."
  },
  {
    icon: FaPaperclip,
    imgAlt: "File Sharing",
    title: "File Sharing",
    description: "Effortlessly share documents, images, and videos with robust file-sharing capabilities."
  },
  {
    icon: FaBell,
    imgAlt: "Customizable Notifications",
    title: "Customizable Notifications",
    description: "Stay notified without interruptions using personalized notification settings tailored to your needs."
  },
  {
    icon: FaCamera,
    imgAlt: "Status Sharing",
    title: "Status Sharing",
    description: "Express yourself by sharing text, photos, or videos as status updates with your contacts."
  },
  {
    icon: FaDesktop,
    imgAlt: "Cross-Platform Compatibility",
    title: "Cross-Platform Compatibility",
    description: "Use Harsafe Meet on mobile or desktop for uninterrupted communication anytime."
  },
  {
    icon: FaCloudUploadAlt,
    imgAlt: "Secure Backup Options",
    title: "Secure Backup Options",
    description: "Keep your data safe with encrypted backup and restore options in the cloud."
  },

];


const ServiceSection = () => {
  return (
    <div className="section harsafe-servicess-section section-padding">
      <div className="container">
        <div className="services-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">Services</h3>
            <h2 className="title">Affordable Services for all</h2>
          </div>
          <div className="service-content-wrap">
            <div className="row right_choice_inner best_choice_inner mt-3">
              {services.map((service, index) => (
                <div key={index} className="col-lg-4 col-sm-6">
                  <div className="counter-item choice-item grayscale_img">
                    <div className="modalBoximg">
                    <service.icon className="service-icon" />
                      {/* <img src={service.imgSrc} alt={service.imgAlt} /> */}
                    </div>
                    <h4>{service.title}</h4>
                    <p>{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
